import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import HeroSection from "@/pages/home/components/HeroSection";
import TickerBar from "@/pages/home/components/TickerBar";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import HotArticles from "@/pages/home/components/HotArticles";
import ExclusiveSpotlight from "@/pages/home/components/ExclusiveSpotlight";
import EditorPicks from "@/pages/home/components/EditorPicks";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import { articles } from "@/mocks/articles";
import { faqs } from "@/mocks/faqs";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "爆料在线",
      url: "https://mtx360.cn/",
      description: "专注独家内容的爆料资讯门户，输出首发猛料、内幕消息与独家调查。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "CollectionPage",
      name: "爆料在线 · 首页",
      url: "https://mtx360.cn/",
      mainEntity: {
        "@type": "ItemList",
        itemListElement: articles.slice(0, 6).map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `https://mtx360.cn/article/${item.id}`,
          name: item.title,
        })),
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <SiteLayout>
      <Seo
        title="爆料在线 - 独家猛料首发内幕，微八卦深度调查"
        description="爆料在线专注独家内容，持续输出首发猛料、内幕消息与独家调查，微八卦视角深挖细节，给你别处看不到的深度爆料。"
        keywords="爆料在线,独家猛料,首发内容,内幕消息,独家调查,微八卦"
        canonical="https://mtx360.cn/"
        jsonLd={homeJsonLd}
      />
      <HeroSection />
      <TickerBar />
      <CategoryStrip />
      <HotArticles />
      <ExclusiveSpotlight />
      <EditorPicks />
      <FaqSection />
      <SubscribeSection />
    </SiteLayout>
  );
}